import { render } from "./MessageForm.vue?vue&type=template&id=b6e301c8&ts=true"
import script from "./MessageForm.vue?vue&type=script&lang=ts"
export * from "./MessageForm.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/my-pages-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__